<iss-typeahead-select
  [formControl]="control.control"
  [items$]="items$"
  [loading$]="loading$"
  [placeholder]="placeholder || 'iss-wo-common.label.supplier' | translate"
  [readonly]="readonly"
  [withAll]="withAll"
  [stringify]="stringify"
  [content]="content"
  [identity]="identity"
  [matcher]="matcher"
  [multi]="multi"
  [loading]="loading"
  [forceTypeahead]="forceTypeahead"
  [clearable]="clearable"
>
  <wo-details-box
    *issTypeaheadSelectItem="let supplier=item"
    [primary]="supplier.organization.name"
    [secondary]="secondaryLabelFn(supplier.id)"
  />
  <ng-content/>
</iss-typeahead-select>
